/**
 *  Initialize SVG Polyfill
 */

var svg = (function() {
  var pub = {}; // public facing functions

  pub.init = function() {
    svg4everybody();
  };

  return pub;
})();
